export default __webpack_public_path__ + "static/news3-c31e0ca1d86c1a715d2544560bb98465.png";